import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  BodyWrapper,
  Header,
  Loader,
  MainWrapper,
  SocialForm,
} from '@components';
import { businessQuery, locationQuery, locationMutation } from '@queries';

import { LocationBreadcrumbs } from '../components/LocationBreadcrumbs/LocationBreadcrumbs.jsx';
import { LocationSidebar } from '../components/LocationSidebar/LocationSidebar.jsx';

export const LocationSocial = () => {
  const { businessID, locationID } = useParams();
  const { t, i18n } = useTranslation();
  const queryClient = useQueryClient();

  // Fetches business
  const { data: businessData, isPending: businessIsPending } = useQuery(
    businessQuery(businessID),
  );

  // Fetches business
  const { data: locationData, isPending: locationIsPending } = useQuery(
    locationQuery(locationID),
  );

  // save location
  const mutation = useMutation(
    locationMutation(locationID, {
      onSuccess: () => {
        // invalidate the lists so its purged
        queryClient.invalidateQueries({ queryKey: ['locations', 'list'] });
        // invalidate the detail for revisits
        queryClient.invalidateQueries({
          queryKey: ['locations', 'detail', locationID],
        });
      },
    }),
  );

  return (
    <>
      <Header />
      <BodyWrapper>
        <LocationSidebar businessID={businessID} locationID={locationID} />
        <MainWrapper>
          <LocationBreadcrumbs
            businessData={businessData}
            locationData={locationData}
          >
            <li className="sb-flex">
              <span>{t('Social media')}</span>
            </li>
          </LocationBreadcrumbs>
          <div className="sb-manage-content">
            <h1>{t('Social media')}</h1>
            {locationIsPending && (
              <Loader className="sb-loader sb-loader-large" />
            )}
            {locationData && (
              <>
                <SocialForm locationData={locationData} mutation={mutation} />
              </>
            )}
          </div>
        </MainWrapper>
      </BodyWrapper>
    </>
  );
};
